import { AuthenticationService } from './authentication.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from './User';
import { Observable ,  of } from 'rxjs';
import { Router } from '@angular/router';
import { LocalStorage } from './localstorage.service';
import { reject } from 'q';

@Injectable()
export class UserService {
    constructor(
        private http: HttpClient,
        private _router: Router,
        private localStorage: LocalStorage,
        private _authService: AuthenticationService) { }
    currentUser = new User();
    getUser(username: string, password: string, state: string) {
        return new Promise<User>(resolve => {
            this.http.get<User>('/api/login/', {
                params: { username: username, password: password, state: state }
            })
                .subscribe(data => {
                    this._authService.set(data['token'], data['userName'], data['role'], data['currentState'], password);
                    this.currentUser = data;
                    this.currentUser.passWord = password;
                    resolve(this.currentUser);
                });
            setTimeout(() => resolve(this.currentUser = new User()), 100000);
        });
    }

    clearUser() {
        location.reload();
        this._authService.clear();
        this.localStorage.removeItem('userName');
        this.localStorage.removeItem('token');
        this.localStorage.removeItem('isAuthenticated');
        this.localStorage.removeItem('role');
        this.localStorage.removeItem('currentState');
        this._router.navigate(['/login']);
    }
}
